import React from 'react';
import { Tag, Tooltip } from 'antd';

import { isDemoItem } from '../../services/records';

/**
 * "Demo": this record is an example a Discover package brought (keepr-api
 * `provenance.demo`), not something a person wrote. Said on the record, so
 * nobody mistakes it for real data; the API clears the mark on the first
 * human edit, and the tag goes with it. Renders nothing for any other item,
 * so every surface can drop it in unconditionally.
 */
export default function DemoTag({ item, className = '' }) {
	if (!isDemoItem(item)) return null;
	return (
		<Tooltip title="An example record that came with a package. Edit it, comment on it or attach a file to make it yours, or remove all the demo data from the collection menu.">
			<Tag className={['demo-tag', className].filter(Boolean).join(' ')} data-testid="demo-tag">
				Demo
			</Tag>
		</Tooltip>
	);
}
